import { Validators } from '@angular/forms';
import { IColumnConfigTableResponsive } from 'src/app/domain/IColumnConfigTableResponsive';
import { LegalPersonalityEnum } from 'src/app/domain/enums/legal-personality.enum';
import { FieldTypeEnum } from 'src/app/domain/registration/enums/field-type.enum';
import { RegimeTypeEnum } from 'src/app/domain/registration/enums/regime-type.enum';
import { TableResponsiveTypeColumnEnum } from 'src/app/domain/registration/enums/table-responsive-type-column.enum';
import { TypeComponentFieldEnum } from 'src/app/domain/registration/enums/type-component-dynamic.enum';
import { PartnerIndexSelectComponent } from './crud-index/crud-index-select.component';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { SystemIndexSelectComponent } from '../systems/crud-index/crud-index-select.component';

export const RELATIVE_URL = 'partners';

export const COLUMNS_TO_SHOW_WEB = [
  'select',
  'image',
  'code',
  'document',
  'name',
  'tradingName',
  'cellPhone',
  'birthday',
  'cutoffDay',
  'transferDay',
  'isContractGenerated',
  'isContractSigned',
  'createdAt',
  'actions',
];
export const COLUMNS_TO_SHOW_MOBILE = COLUMNS_TO_SHOW_WEB;
export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
  {
    link_show: true,
    field_type: FieldTypeEnum.LABEL,
    property: 'code',
    display: 'CÓDIGO',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE}`,
  },
  {
    link_show: true,
    field_type: FieldTypeEnum.IMAGE,
    property: 'image',
    class: `${TableResponsiveTypeColumnEnum.SUBTITLE} image-size`,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'document',
    display: 'CNPJ/CPF',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'name',
    display: 'Parceiro',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    maxLength: 25
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'tradingName',
    display: 'Fantasia',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
    maxLength: 25
  },
  {
    field_type: FieldTypeEnum.LABEL_DATE,
    link_show: true,
    property: 'birthday',
    display: 'Data de Nascimento',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'stateRegistration',
    display: 'IE',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'municipalRegistration',
    display: 'Incr. Municipal',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'phone',
    display: 'Telefone',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'cellPhone',
    display: 'Celular',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'email',
    display: 'E-mail',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'webSite',
    display: 'Web Site',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  // {
  //   field_type: FieldTypeEnum.LABEL,
  //   link_show: true,
  //   property: 'address',
  //   display: 'Endereço',
  //   class: TableResponsiveTypeColumnEnum.SUBTITLE,
  // },
  // {
  //   field_type: FieldTypeEnum.LABEL,
  //   link_show: true,
  //   property: 'loginScreenLogo',
  //   display: 'Logo Tela Login',
  //   class: TableResponsiveTypeColumnEnum.SUBTITLE,
  // },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'supportContact',
    display: 'Contato Suporte',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'cutoffDay',
    display: 'Dia de Corte',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL,
    link_show: true,
    property: 'transferDay',
    display: 'Dia de Repasse',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'isContractGenerated',
    display: 'C.: Gerado',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  {
    field_type: FieldTypeEnum.LABEL_FLAG,
    link_show: true,
    property: 'isContractSigned',
    display: 'C.: Assinado',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
  
  {
    field_type: FieldTypeEnum.LABEL_DATE,
    link_show: true,
    property: 'createdAt',
    display: 'CRIADO EM',
    class: TableResponsiveTypeColumnEnum.SUBTITLE,
  },
];

export const CES_CONFIG_FIELDS = [
  // id - hidden
  {
    type: TypeComponentFieldEnum.HIDDEN,
    name: 'id',
  },
  // sessao - 1
  // imagem - image
  {
    name: 'image',
    type: TypeComponentFieldEnum.IMAGE,
  },
  // codigo - input
  {
    label: 'CÓDIGO',
    name: 'code',
    type: TypeComponentFieldEnum.INPUT,
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Personalidade Jurídica',
    name: 'legalPersonality',
    value: LegalPersonalityEnum.PESSOA_FISICA,
    options: Object.values(LegalPersonalityEnum),
  },
  // cpf / cnpj - input
  {
    label: 'CPF',
    name: 'cpf',
    type: TypeComponentFieldEnum.INPUT_CPF,
    validation: [Validators.required, Validators.minLength(11)],
    onBlur: 'checkCustomerDocument',
    mask: '000.000.000-00'
  },
  // cpf / cnpj - input
  {
    label: 'CNPJ',
    name: 'cnpj',
    type: TypeComponentFieldEnum.INPUT_CNPJ,
    validation: [Validators.required, Validators.minLength(14)],
    onBlur: 'checkCustomerDocument',
  },
  // razão social - input
  {
    label: 'Nome',
    name: 'name',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    label: 'Razão Social',
    name: 'companyName',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  // fantasia - input
  {
    label: 'FANTASIA',
    name: 'tradingName',
    type: TypeComponentFieldEnum.INPUT,
    validation: [Validators.required, Validators.minLength(4)],
  },
  // rg - input
  {
    label: 'RG',
    name: 'generalRegistration',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    validation: [Validators.required, Validators.pattern(/\d+/)],
  },
  // ie - input
  {
    label: 'IE',
    name: 'stateRegistration',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
  },
  // incr. municipal - number
  {
    label: 'INCR. MUNICIPAL',
    name: 'municipalRegistration',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
  },
  // regime - select
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'REGIME',
    name: 'regime',
    options: Object.values(RegimeTypeEnum),
    value: RegimeTypeEnum.SIMPLE,
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  // telefone - input phone
  {
    label: 'TELEFONE',
    name: 'phone',
    type: TypeComponentFieldEnum.INPUT_PHONE,
  },
  // celular - input phone
  {
    label: 'CELULAR',
    name: 'cellPhone',
    type: TypeComponentFieldEnum.INPUT_CELLPHONE,
    validation: [Validators.required, Validators.minLength(11)],
  },
  // email - input email
  {
    label: 'EMAIL',
    name: 'email',
    type: TypeComponentFieldEnum.INPUT_EMAIL,
    validation: [Validators.required, Validators.email],
  },
  // web site - input
  {
    label: 'WEB SITE',
    name: 'webSite',
    type: TypeComponentFieldEnum.INPUT,
  },
  // data de nascimento - input date
  {
    label: 'DATA DE NASCIMENTO',
    name: 'birthday',
    type: TypeComponentFieldEnum.INPUT_DATE,
    validation: [Validators.required],
  },
  // sessao - 2
  // sessao - 3
  {
    type: TypeComponentFieldEnum.INPUT_CEP,
    label: 'CEP',
    name: 'cep',
    placeholder: 'Insira o CEP',
    validation: [Validators.required, Validators.minLength(7)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Endereço',
    name: 'address',
    placeholder: 'Insira o endereço',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Complemento',
    name: 'addressComplement',
    placeholder: 'Insira o complemento se houver',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    label: 'Número',
    name: 'addressNumber',
    placeholder: 'Insira o número caso houver',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Bairro',
    name: 'neighborhood',
    placeholder: 'Insira o bairro',
    validation: [Validators.required, Validators.minLength(4)],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Estado',
    name: 'state',
    placeholder: 'Insira a UF do estado',
    options: [],
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'Cidade',
    name: 'city',
    placeholder: 'Insira o nome da cidade',
    validation: [],
    options: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'Observação',
    name: 'addressObservation',
    placeholder: 'Insira uma observação',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'País',
    name: 'country',
    placeholder: 'Insira o pais',
    validation: [],
  },
  // sessao - 4
  // logo tela login - image
  {
    label: 'LOGO TELA LOGIN',
    name: 'loginScreenLogo',
    type: TypeComponentFieldEnum.IMAGE,
  },
  // contato suporte - input
  {
    label: 'CONTATO SUPORTE',
    name: 'supportContact',
    type: TypeComponentFieldEnum.INPUT_PHONE,
  },
  // campos de corte e repasse
  {
    label: 'Dia de Corte',
    name: 'cutoffDay',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    validation: [Validators.required, Validators.min(1), Validators.max(31)],
  },
  {
    label: 'Dia de Repasse',
    name: 'transferDay',
    type: TypeComponentFieldEnum.INPUT_NUMBER,
    validation: [Validators.required, Validators.min(1), Validators.max(31)],
  },

  // horario atendimento - period
  // SUNDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'DOM',
    name: 'checkSundayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startSundayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endSundayBusinessHour',
  },
  // MONDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'SEG',
    name: 'checkMondayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startMondayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endMondayBusinessHour',
  },
  // TUESDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'TER',
    name: 'checkTuesdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startTuesdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endTuesdayBusinessHour',
  },
  // WEDNESDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'QUA',
    name: 'checkWednesdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startWednesdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endWednesdayBusinessHour',
  },
  // THURSDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'QUI',
    name: 'checkThursdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startThursdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endThursdayBusinessHour',
  },
  // FRIDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'SEX',
    name: 'checkFridayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startFridayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endFridayBusinessHour',
  },
  // SATURDAY
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'SAB',
    name: 'checkSaturdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'INICIO',
    name: 'startSaturdayBusinessHour',
  },
  {
    type: TypeComponentFieldEnum.INPUT,
    label: 'FIM',
    name: 'endSaturdayBusinessHour',
  },

  // web site / link - input
  {
    label: 'WEB SITE / LINK',
    name: 'webSiteLink',
    type: TypeComponentFieldEnum.INPUT,
  },
  // comentário - input
  {
    label: 'COMENTÁRIO',
    name: 'comment',
    type: TypeComponentFieldEnum.INPUT,
  },
  {
    type: TypeComponentFieldEnum.SELECT,
    label: 'TIPO',
    name: 'type',
    options: Object.values(SystemTypeEnum),
    placeholder: 'Selecione uma opção',
    validators: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    label: 'Sistema',
    component: SystemIndexSelectComponent,
    componentData: {
      params: { type: SystemTypeIdEnum[SystemTypeEnum.SYSTEM] },
    },
    name: 'system',
    value: 'name',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
    validation: [Validators.required],
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: PartnerIndexSelectComponent,
    componentData: { params: { isConsultant: true } },
    label: 'CONSULTOR',
    name: 'consultant',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: PartnerIndexSelectComponent,
    componentData: { params: { isPartner: true } },
    label: 'PARCEIRO',
    name: 'partner',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.SELECT_CRUD,
    component: PartnerIndexSelectComponent,
    componentData: { params: { isRepresentative: true } },
    label: 'REPRESENTANTE',
    name: 'representative',
    defaultValue: ' ',
    options: [Object.values([])],
    placeholder: 'Selecione uma opção',
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO DO CONSULTOR',
    name: 'consultantCommission',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO DO PARCEIRO',
    name: 'partnerCommission',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO DO REPRESENTANTE',
    name: 'representativeCommission',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO DO CONTADOR',
    name: 'counterCommission',
    validation: [],
  },
  {
    type: TypeComponentFieldEnum.INPUT_PERCENT,
    label: 'COMISSÃO DA UNIDADE',
    name: 'unitCommission',
    validation: [],
  },
  // IS CONSULTANT
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'É CONSULTOR',
    name: 'isConsultant',
  },
  // IS PARTNER
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'É PARCEIRO',
    name: 'isPartner',
  },
  // IS REPRESENTATIVE
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'É REPRESENTANTE',
    name: 'isRepresentative',
  },
  // IS COUNTER
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'É CONTADOR',
    name: 'isCounter',
  },
  // IS UNIT
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'É UNIDADE',
    name: 'isUnit',
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'É FORNECEDOR',
    name: 'isSupplier',
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'REVENDA',
    name: 'isResale',
  },
  {
    type: TypeComponentFieldEnum.SLIDE_TOGGLE,
    label: 'COMERCIANTE',
    name: 'isMerchant',
  },
];
